module.exports = __webpack_public_path__ + "img/fb.862469d3.png";